import React from "react";
import { Tooltip } from "..";
import { useTooltipStyles } from "../InfoTooltip/InfoTooltip.styles";
import { useStyles } from "./OverFlowTipStyles";

export interface OverFlowTipProps {
  text?: string;
  bgColor?: "white" | "grey";
  onClick?: () => void;
}

function OverFlowTip(props: OverFlowTipProps): JSX.Element {
  const { text, bgColor = "white", onClick } = props;
  const [hoverStatus, setHover] = React.useState(false);
  const tooltipClasses = useTooltipStyles({ bgColor, title: null });
  const classes = useStyles(props);

  const textElementRef = React.useRef<HTMLDivElement>(null);
  const compareSize = () => {
    if (textElementRef.current) {
      const compare =
        textElementRef.current.scrollWidth > textElementRef.current.clientWidth;
      setHover(compare);
    }
  };

  React.useEffect(() => {
    compareSize();
    window.addEventListener("resize", compareSize);
    return () => {
      window.removeEventListener("resize", compareSize);
    };
  }, []);
  return (
    <Tooltip
      classes={tooltipClasses}
      title={text || ""}
      arrow
      placement="bottom-start"
      disableInteractive={false}
      disableHoverListener={!hoverStatus}
    >
      <div ref={textElementRef} className={classes.text} onClick={onClick}>
        {text}
      </div>
    </Tooltip>
  );
}

export default OverFlowTip;
